import React, { useEffect, useState } from "react";
import aboutFrame from "../assets/images/Frame_1.png";

const About = () => {
  const [marginLeft, setMarginLeft] = useState("-95px");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setMarginLeft("-95px");
      } else {
        setMarginLeft("0px");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className="px-8 lg:px-32 xl:px-52">
      <p className="font-bold text-white text-3xl pt-6">About Us</p>
      <div className="container mx-auto px-2 py-8 text-justify">
      <div className="md:text-[17px] text-white">
        <p className="">
          Welcome to <b>QuickChat</b>, a free, easy-to-use, reliable, and safe
          messaging and calling app designed to help you stay connected with
          your friends, family, and loved ones. Whether you're sending text
          messages, making voice or video calls, or engaging in group chats,
          <b>QuickChat</b> offers a smooth, friendly, and hassle-free communication
          experience. Built for Android phones, this app provides a seamless
          platform for all your messaging needs, ensuring you stay connected in
          a secure environment. <br /><br/>
          Stay connected with <b>QuickChat</b> – the messaging app that makes
          communication easier and more enjoyable. Download it today and
          experience a better way to stay in touch with your friends and family.<br/><br/>
          <b>QuickChat</b> prioritizes your privacy and data security. With top-notch encryption and a strong commitment to protecting your information, you can enjoy peace of mind while using the app. The interface is designed to be intuitive, so even first-time users can easily navigate the app without confusion.<br/><br/>
          Our mission at <b>QuickChat</b> is to make communication simple, fast, and accessible for everyone. Whether you’re sending a quick text or having a lengthy conversation, you can rely on our app to provide a smooth and enjoyable experience. There’s no need for complicated setups or confusing features – just a straightforward way to communicate with the people who matter most. <br/><br/> 
          Stay connected with <b>QuickChat</b> – the messaging app that makes communication easier and more enjoyable. Download it today and experience a better way to stay in touch with your friends and family. 
        </p>
        </div>
      </div>
    </div>
  );
};

export default About;
